export default __webpack_public_path__ + "static/media/bank_details_icon.4086ff82.svg";